var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"profile__charts__container"},[_c('div',{staticClass:"sales_report__container"},[_c('ReportFilter',{attrs:{"report-type":"payments","report-filename":"PaymentsReport"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }